<template>
  <component :is="tag" v-bind="$attrs" :class="classes">
    <slot />
  </component>
</template>

<script>
export default {
  name: "BaseNavbarNav",
  inheritAttrs: false,
  props: {
    tag: { type: String, default: "ul" },

    align: { type: String, default: null },

    fill: { type: Boolean, default: false },

    justified: { type: Boolean, default: false },

    small: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      const cls = ["navbar-nav"];

      // horizontal alignment
      if (this.align) {
        let a = this.align;
        if (a === "left") a = "start";
        if (a === "right") a = "end";
        cls.push(`justify-content-${a}`);
      }

      // fill vs. justified
      if (this.fill) cls.push("nav-fill");
      if (this.justified) cls.push("nav-justified");

      // smaller text
      if (this.small) cls.push("small");

      return cls;
    },
  },
};
</script>
